<template>
  <div class="trending-up">
    <div class="icon-container">
      <mf-icon color="white" size="16" icon="trending_up" fill />
    </div>
    <span>
      <strong>{{ trendingUpText.bold }}</strong> {{ trendingUpText.normal }}
    </span>
  </div>
</template>

<script>
import { localeString } from '@/config/helpers.js'

export default {
  name: 'TrendingUp',
  props: {
    offerScheduleType: {
      type: String,
      required: true,
      validator: (value) =>
        ['takepay', 'general', 'percentage', 'next_buy_cashback', 'cashback_absolute', 'dynamic_rule_offer_sales', 'crosssell'].includes(value),
    },
    offerSales: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    trendingUpText() {
      switch (this.offerScheduleType) {
        case 'takepay':
          const diff = this.offerSales[0].take - this.offerSales[0].pay
          return {
            bold: diff === 1 ? `${diff} unidade será reembolsada` : `${diff} unidades serão reembolsadas`,
            normal: `a cada ${this.offerSales?.[0]?.take || 0} vendidas!`,
          }
        case 'general':
          return {
            bold: `Você recebe R$ ${localeString(this.offerSales?.[0]?.rebate || 0, 2)}`,
            normal: `a cada unidade vendida nessa oferta!`,
          }
        case 'percentage':
          return {
            bold: 'Todo desconto concedido é pago pela indústria!',
            normal: '',
          }
        case 'next_buy_cashback':
        case 'cashback_absolute':
          return {
            bold: 'O Cashback será pago integralmente pela indústria!',
            normal: '',
          }
        case 'dynamic_rule_offer_sales':
          return {
            bold: 'O Voucher é adquirido e disparado pela indústria.',
            normal: '',
          }
        case 'crosssell':
          return {
            bold: 'Todo o desconto concedido é pago pela indústria!',
            normal: '',
          }
        default:
          return { bold: '', normal: '' }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.trending-up {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 4px 16px;
  border-radius: 16px;
  background: #0fc94d1a;
  width: fit-content;

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    background-color: $verde-l10;
  }

  & span {
    font-size: 14px;
    user-select: none;
    color: $verde-0;
  }
}
</style>
